import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="specific--admin-einstellungen"
export default class extends Controller {
  static targets = ["codeInput"];
  static values = {
    currentEnvironment: String,
  };

  impersonieren({ detail: { content } }) {
    let data = typeof content === "string" ? content : content?.data;
    data = this.parseData(data);

    if (data) {
      const { auth_token, env } = data;

      if (env !== this.currentEnvironment) {
        this.stopScanning();
        alert(`Ungültig! Gescannter QR-Code stammt von ${env} und nicht von ${this.currentEnvironment}`);
      } else if (auth_token) {
        Turbo.visit(`/?auth_token=${auth_token}`);
        this.stopScanning();
      }
    }
  }

  impersonierenViaCode(event) {
    event.preventDefault();
    const raw = (this.codeInputTarget.value || "").trim();
    if (!raw) return;

    const trennzeichen = raw.indexOf(":");
    if (trennzeichen === -1) {
      alert("Ungültiger Code");
      return;
    }
    const env = raw.slice(0, trennzeichen);
    const auth_token = raw.slice(trennzeichen + 1);

    if (env !== this.currentEnvironment) {
      alert(`Ungültig! Code stammt von ${env} und nicht von ${this.currentEnvironment}`);
      return;
    }
    if (!auth_token) {
      alert("Ungültiger Code");
      return;
    }

    Turbo.visit(`/?auth_token=${auth_token}`);
  }

  parseData(data) {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error('Invalid JSON:', data);
      return null;
    }
  }

  stopScanning() {
    window.dispatchEvent(new Event('stop-scanning'));
  }

  get currentEnvironment() {
    return this.currentEnvironmentValue;
  }
}
